// extracted by mini-css-extract-plugin
module.exports = {"page_section":"temp_page_section__26PMV","text":"temp_text__212bB"};